import React from "react";
import ReactDOM from "react-dom/client";

// Import all components dynamically from the components directory
const componentsContext = import.meta.glob("../components/*.tsx", {
  eager: true,
});

// Create a map of component names to their default exports
const components = Object.fromEntries(
  Object.entries(componentsContext).map(([key, module]) => {
    const componentName = key.split("/").pop().replace(".tsx", "");
    return [componentName, module.default];
  })
);

console.log("Registered components:", Object.keys(components));

// Function to mount a React component dynamically
const mountComponent = (element) => {
  const componentName = element.dataset.reactComponent;
  const Component = components[componentName];

  if (Component) {
    const props = JSON.parse(element.dataset.reactProps || "{}");
    const root = ReactDOM.createRoot(element);
    root.render(<Component {...props} />);
  } else {
    console.error(`Component '${componentName}' not found.`);
  }
};

// Wait for the DOM to load and mount all components
document.addEventListener("DOMContentLoaded", () => {
  const reactElements = document.querySelectorAll("[data-react-component]");
  reactElements.forEach(mountComponent);
});
